module.exports = __webpack_public_path__ + "static/media/полулюкс 2.93ff4117.jpg";